import type { ReactNode } from "react";

type FunnelShellProps = {
  topBar: ReactNode;
  bottomBar?: ReactNode;
  isScrollable: boolean;
  children: ReactNode;
};

export const FunnelShell = ({ topBar, bottomBar, isScrollable, children }: FunnelShellProps) => {
  return (
    <main className="funnel-shell">
      {topBar}
      <section
        className={`funnel-content ${isScrollable ? "funnel-content-scrollable" : "funnel-content-locked"}`}
      >
        {children}
      </section>
      {bottomBar}
    </main>
  );
};
